<div data-test-id="snackbar" class="message-container" [ngClass]="{ 'success': type === 'success', 'info': type === 'info', 'error': type === 'error'}" [ngStyle]="color ? { 'border-color': color } : {}">
    
    <div data-test-id="icon" [ngSwitch]="type" style="display: flex">
        <img data-test-id="image" class="icon" *ngSwitchCase="'success'" [src]="'./assets/tick.svg'" alt="Verified">
        <img data-test-id="image" class="icon" *ngSwitchCase="'info'" [src]="'./assets/info.svg'" alt="Info">
        <img data-test-id="image" class="icon" *ngSwitchCase="'error'" [src]="'./assets/error.svg'" alt="Warning">
    </div>
    <span data-test-id="message" [innerHtml]="message" matSnackBarLabel></span>
    <span matSnackBarActions>
        <button data-test-id="dismissActionButton" mat-icon-button (click)="snackBarRef.dismissWithAction()">
            <mat-icon data-test-id="icon" matSnackBarAction>close</mat-icon>
        </button>
    </span>
</div>
 